<template>
    <div>

        <div style="background: #f1f1f1; padding: 5px 10px; border-bottom: 1px solid #ccc">
            <el-row :gutter="20">
                <el-col :sm="6" :offset="0">
                    <h4 style="margin:10px 20px">Normalizador de teléfonos</h4>
                </el-col>
             
            </el-row>
        </div>

        <div style="margin:10px auto; padding: 10px 30px">
            <el-row :gutter="20">
                <el-col :md="8" :offset="0">
                    <small for="">Validar teléfono</small>
                    <el-input placeholder="" clearable="" @clear="clear" v-model="telefono" size="medium" @keypress.enter.native="checkNumber">

                        <el-button slot="append" icon="el-icon-phone" :loading="creando"     @click="checkNumber">Validar</el-button>
                    </el-input>
                    <div v-if="false">
                        <h5>Reportar</h5>
                        <el-input v-model="telData.obs" placeholder="" size="normal" type="textarea"
                            :rows="4"></el-input>

                        <el-button type="danger" style="float:right" :loading="repordando" size="mini"
                            @click="checkNumber">Reportar</el-button>
                    </div>
                </el-col>
                <el-col :md="12" :offset="0">
                    <h3>Normalizador + Normas</h3>

                    <table class="table table-sm" v-if="telefono && telData2">
                        <tr v-for="(value, key) in telData2" :key="key">
                            <td><strong>{{ key }}</strong></td>
                            <td>
                                <template v-if="typeof value === 'object' && value !== null && key != 'partes'">
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr v-for="(subValue, subKey) in value" :key="subKey">
                                                <td><strong>{{ subKey }}</strong></td>
                                                <td>{{ subValue }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                                <template v-else>
                                    {{ value }}
                                </template>
                            </td>
                        </tr>
                    </table>

                </el-col>


            </el-row>



        </div>
    </div>
</template>

<script>
import { HTTP } from "@/axios"
import { EventBus } from "@/event-bus"
export default {
    data() {
        return {
            creando: false,
            telefono: '',
            validaTel: false,
            telData: undefined,
            telData2: undefined
        }
    },
    created() {
        EventBus.$on('validar', (v) => {
            this.telefono = v
            setTimeout(() => {
                this.checkNumber()

            }, 100);
        })
    },
    methods: {
        clear() {
            this.telefono = ''
            this.validaTel = false
            this.telData = undefined
            this.telData2 = undefined
        },
        checkNumber() {
            this.creando = true
            HTTP.post('tto/checkNumber', { numero: this.telefono })
                .then(res => {
                    this.validaTel = true
                    this.telData = res.data
                    // console.log(res.data);
                    this.checkNumberBot()
                    this.creando = false
                })
                .catch(() => {
                    this.creando = false
                    this.$alert('Error en servidor')
                })
        },
        checkNumberBot() {
            this.creando = true
            HTTP.post('tto/checkNumberBot', { numero: this.telefono })
                .then(res => {
                    this.validaTel = true
                    this.telData2 = res.data
                    // console.log(res.data);
                    this.creando = false
                })
                .catch(() => {
                    this.creando = false
                    this.$alert('Error en servidor')
                })
        },
    },
}
</script>

<style lang="scss" scoped></style>